class TableAccordion {
  init(containerClass, wrapperClass, toggleClass) {
    let container = document.querySelectorAll(containerClass);

    container.forEach((elem) => {
      let toggle = elem.querySelector(toggleClass);
      let wrapper = elem.querySelector(wrapperClass);

      if (toggle) {
        toggle.addEventListener('click', function () {
          [this, wrapper].forEach(item => {
            item.classList.toggle('open')
          });
        });
      }
    })
  }
}

export default TableAccordion;



// WEBPACK FOOTER //
// ./scripts/util/table-accordion.js